namespace $.$$ {
	/** Standalone link text: `$eve_text` + `interactive` + `underline` modifier. */
	export class $eve_link extends $.$eve_link {}
}
